import { render } from "./RealtimeAuthentication.vue?vue&type=template&id=6f92a53f&scoped=true"
import script from "./RealtimeAuthentication.vue?vue&type=script&lang=js"
export * from "./RealtimeAuthentication.vue?vue&type=script&lang=js"

import "./RealtimeAuthentication.vue?vue&type=style&index=0&id=6f92a53f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f92a53f"]])

export default __exports__